import { Component, Output, EventEmitter } from '@angular/core';
import { DwUtils } from 'src/app/components/utils/dw-utils';
import { HouseholdMember } from 'src/app/models/household-member';
import { ValidationResult } from 'src/app/models/validation-result';
import { ServiceRequestsService } from 'src/app/services/service-requests.service';
import { Settings } from 'src/app/services/settings';
import {TransactionHistoryService} from "../../../../../services/transactionhistory.service";
import {Data} from "@angular/router";
import {CasesService} from "../../../../../services/cases.service";
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import {
	ConfirmDialogComponent,
	ConfirmDialogModel
} from 'src/app/components/shared/confirmation-dialog/confirmation-dialog.component';
import { ServiceRequestMemberHistory } from 'src/app/models/service-request-member-history';

class DataRecord {
	id:string;
	description: string;
	constructor(id:string, desc:string) {
		this.id = id;
		this.description = desc;
	}
}
@Component({
	selector: 'app-addeditmember',
	templateUrl: './addeditmember.component.html',
	styleUrls: ['./addeditmember.component.css']
})
export class AddeditmemberComponent {

	public isAdd: boolean;
	public caseId: number;
	public valId: number
	public valFirstName: string;
	public valMiddleName: string;
	public valLastName: string;
	public valDob: string;
	public valGender: string;
	public valRelationship: string;
	public valMemberComments: string;
	public selectedRecord: any;
	public historyMember: any;
	public selectedRelationship: string;
	public strErr = '';
	public relationshipList: Array<DataRecord>;
	public genderList: Array<DataRecord>;
	public advocateFlag: boolean = false;
	public submitEnabled: boolean = false;
	public editDOB = false;
	public viewDOB = false;
	public editComment= false;
	public viewComment= false;
	public editPrimaryApplicant: boolean = false;
	public householdMembers: any[] = [];
	/** Set to true when editing from a closed/clerically-reopened request.
	 *  Saves go to ServiceRequestMemberHistory instead of the live member table. **/
	public isHistoryMode = false;
	public historyServiceRequestId = 0;
	public caseAddress = '';

	@Output() cancelClicked = new EventEmitter();
	@Output() submitClicked = new EventEmitter<any>();

	constructor(private serviceRequestsService: ServiceRequestsService,
				private caseService: CasesService,
				public txHistory:TransactionHistoryService,
				public dialog: MatDialog) {

		this.queryRelationshipTypes();

		/** gender list **/
		this.genderList = new Array();
		this.genderList.push(new DataRecord('Male', 'Male'));
		this.genderList.push(new DataRecord('Female', 'Female'));
		this.genderList.push(new DataRecord('Unknown', 'Unknown'));
		this.genderList.push(new DataRecord('Other', 'Other'));

		this.valMemberComments ='';
	}
	public queryRelationshipTypes(): void {

		this.relationshipList = new Array();
		// Add 'Self' option if editPrimaryApplicant privilege is enabled
		if (this.editPrimaryApplicant) {
			this.relationshipList.push(new DataRecord('Self', 'Self'));
		}
		this.serviceRequestsService.getSelectableRelationshipTypes().subscribe(
			(results) => {
				for(let rec of results) {
					this.relationshipList.push(new DataRecord(rec.description, rec.description));
				}
			},
			(error) => {
				Settings.getInstance().handleError(error, 'fetching relationship types');
			}
		)
	}
	public onShowHandler(isAdd: boolean, caseId: number, member: any, editDOB, viewDOB, editComment, viewComment, editPrimaryApplicant = false, householdMembers: any[] = [], isHistoryMode = false, serviceRequestId = 0, caseAddress = '') {
		this.strErr = '';
		this.isAdd = isAdd;
		this.caseId = caseId;
		this.submitEnabled = true;
		this.viewComment = viewComment;
		this.editComment = editComment;
		this.viewDOB = viewDOB;
		this.editDOB = editDOB;
		this.editPrimaryApplicant = editPrimaryApplicant;
		this.householdMembers = householdMembers;
		this.isHistoryMode = isHistoryMode;
		this.historyServiceRequestId = serviceRequestId;
		this.caseAddress = caseAddress;
		this.queryRelationshipTypes();

		if (isAdd) {
			this.selectedRecord = new HouseholdMember();
			this.selectedRecord.id = 0;
			this.selectedRecord.caseId = this.caseId;
			this.selectedRecord.duplicateStatus = 'N';			/** no duplicates **/
			this.selectedRelationship = '';

			this.clearFields();
		} else {
			this.selectedRecord = new HouseholdMember();
			this.selectedRecord.id = member.id;
			this.selectedRecord.memberId = member.memberId;
			this.selectedRecord.flatHouseholdMembersId = member.flatHouseholdMembersId;
			this.selectedRecord.flatRequestId = member.flatRequestId;
			this.selectedRecord.caseId = member.caseId;
			this.selectedRecord.firstName = member.firstName;
			this.selectedRecord.middleName = member.middleName;
			this.selectedRecord.lastName = member.lastName;
			this.selectedRecord.dateOfBirth = member.dateOfBirth;
			this.selectedRecord.gender = member.gender;
			this.selectedRecord.memberComments = member.memberComments;

			this.selectedRelationship = member.relationship;
			this.historyMember = new Object();

			Object.assign(this.historyMember,this.selectedRecord);
			this.historyMember['relationship'] = member.relationship;
			this.historyMember['duplicateKey'] = member['duplicateKey'];

			this.displayDetails();
		}
		DwUtils.highlightFocus('firstName');
	}
	public displayDetails() {
		this.setAdvocateFlag();
		this.valId = this.selectedRecord.id;
		this.valFirstName = this.selectedRecord.firstName;
		this.valMiddleName = this.selectedRecord.middleName;
		this.valLastName = this.selectedRecord.lastName;
		this.valRelationship = this.selectedRelationship;
		this.valGender = this.selectedRecord.gender;
		this.valMemberComments = this.selectedRecord.memberComments;

		try {
			this.valDob = this.selectedRecord.dateOfBirth;
			// this.valDob = Settings.getInstance().formatDate(this.selectedRecord.dateOfBirth);
		} catch (Exception) { }
	}
	public doRelationshipTypeSelected(event: any) {
		this.strErr = '';
		// Check if user is trying to set relationship to 'Self'
		if (this.valRelationship === 'Self') {
			// Check if another member already has 'Self' relationship
			if (this.doesSelfExistForAnotherMember()) {
				this.strErr = 'Error: Another family member is already set as the Primary Applicant (Self). Please change that member\'s relationship type first before assigning a new Primary Applicant.';
				// Reset the relationship selection to the previous value
				this.valRelationship = this.selectedRelationship;
				return;
			}
		}
		this.setAdvocateFlag();
	}
	public doesSelfExistForAnotherMember(): boolean {
		if (!this.householdMembers || this.householdMembers.length === 0) {
			return false;
		}
		// Check if any other member (different ID) has 'Self' relationship
		const existingSelf = this.householdMembers.find(member => 
			member.relationship === 'Self' && member.id !== this.selectedRecord.id
		);
		return existingSelf !== undefined;
	}
	public setAdvocateFlag(): void {
		this.valRelationship === 'Advocate' ? this.advocateFlag = true : this.advocateFlag = false;
	}
	public clearFields(){
		this.valId = 0;
		this.valDob = '';
		this.valFirstName = '';
		this.valMiddleName = '';
		this.valLastName = '';
		this.valGender = '';
		this.valRelationship = '';
		this.valMemberComments = '';
		this.advocateFlag = false;
	}
	public cancelSubmitRecord() {
		this.cancelClicked.emit();
	}
	public validateFields(): boolean {

		this.strErr = '';
		const vr: ValidationResult = this.selectedRecord.validateRecord(this.valRelationship);

		if (vr.error.length > 0) {
			this.strErr = vr.error;
			DwUtils.setFocus(vr.focus_field);
			return false;
		}

		if(this.selectedRecord.relationship.length === 0) {
			this.strErr = 'Error: A Relationship type must be selected';
			return false;
		}
		return true;
	}
	public submitRecord() {
		this.submitEnabled = false;
		this.selectedRecord.firstName = DwUtils.capitalize(this.valFirstName);
		if(this.valMiddleName !== null) {
			this.selectedRecord.middleName = DwUtils.capitalize(this.valMiddleName);
		}
		this.selectedRecord.lastName = DwUtils.capitalize(this.valLastName);
		this.selectedRecord.relationship = this.valRelationship;
		this.selectedRecord.memberComments = this.valMemberComments;
		this.selectedRecord.gender = this.valGender;

		try {
			 this.selectedRecord.dateOfBirth = Settings.getInstance().checkDateChange(this.selectedRecord.dateOfBirth, this.valDob);
			//this.selectedRecord.dateOfBirth = Settings.getInstance().convertStringToDate(this.valDob);
		} catch (Exception) {

		}

		/** Recalculate the duplicate key AFTER all fields (including DOB) are updated **/
		this.selectedRecord.setDuplicateKey();

		if (!this.validateFields()) {
			this.submitEnabled = true;
			return;
		}
		if (this.needsSelfChangeConfirmation()) {
			this.openSelfChangeConfirmDialog();
			return;
		}
		this.performSave();
	}

	private performSave(): void {
		/** Clerical reopen / closed-request path — save into ServiceRequestMemberHistory **/
		if (this.isHistoryMode) {
			this.performHistorySave();
			return;
		}
		if (this.isAdd) {
			this.serviceRequestsService.createHouseholdMember(this.selectedRecord).subscribe(
				(data) => {
					/** NOTE - Create Transaction history is handled in the service **/
					if (this.selectedRecord.relationship === 'Self') {
						const recordToUpdate = data || this.selectedRecord;
						this.caseService.updateCaseApplicant(this.caseId, recordToUpdate).subscribe(
							() => {
								this.serviceRequestsService.refreshEvent.emit();
								this.submitClicked.emit();
							},
							(error) => {
								Settings.getInstance().handleError(error, "updating applicant name");
								this.submitClicked.emit();
							});
					} else {
						this.submitClicked.emit();
					}
				},
				(error) => {
					this.strErr = 'Error: The server could not update this record';
					this.submitEnabled = true;
					return;
				});

		} else {
			/** if the name has changed (based on duplicate key)
			 * then reset the duplicate-status to 'N' **/
			if(this.historyMember.duplicateKey !== this.selectedRecord.duplicateKey) {
				this.selectedRecord.duplicateStatus = 'N';
			}
			this.serviceRequestsService.updateHouseholdMember(this.selectedRecord).subscribe(
				(data) => {

					/** update the case applicant **/
					if(this.selectedRecord.relationship === 'Self') {
						this.caseService.updateCaseApplicant(this.caseId, this.selectedRecord).subscribe(

							(result) => {
								this.serviceRequestsService.refreshEvent.emit();
								this.txHistory.updateTransactionHistory(this.historyMember, this.selectedRecord, 'Cases', this.selectedRecord.caseId);
								this.submitClicked.emit();
							},
							(error) => {
								Settings.getInstance().handleError(error, "updating applicant name");
								this.txHistory.updateTransactionHistory(this.historyMember, this.selectedRecord, 'Cases', this.selectedRecord.caseId);
								this.submitClicked.emit();
							});
					} else {
						this.txHistory.updateTransactionHistory(this.historyMember, this.selectedRecord, 'Cases', this.selectedRecord.caseId);
						this.submitClicked.emit();
					}
				},
				(error) => {
					Settings.getInstance().handleError(error, "updating member");
					return;
				});
		}
	}

	private performHistorySave(): void {
		const h = new ServiceRequestMemberHistory();
		h.serviceRequestId = this.historyServiceRequestId;
		h.memberId = this.selectedRecord.memberId || 0;
		h.firstName = this.selectedRecord.firstName;
		h.middleName = this.selectedRecord.middleName || '';
		h.lastName = this.selectedRecord.lastName;
		h.dateOfBirth = this.selectedRecord.dateOfBirth || '';
		h.gender = this.selectedRecord.gender || '';
		h.relationship = this.selectedRecord.relationship || '';
		h.address = this.caseAddress || '';
		h.selected = 0;
		h.createdBy = Settings.getInstance().loggedInUser?.username || 'SYSTEM';

		if (this.isAdd) {
			this.caseService.addMemberToHistory(h).subscribe(
				() => this.submitClicked.emit(),
				(error) => {
					Settings.getInstance().handleError(error, 'adding member to history');
					this.submitEnabled = true;
				}
			);
		} else {
			h.id = this.selectedRecord['historyId'] || this.selectedRecord.id || 0;
			this.caseService.updateMemberHistoryRecord(h).subscribe(
				() => this.submitClicked.emit(),
				(error) => {
					Settings.getInstance().handleError(error, 'updating member history');
					this.submitEnabled = true;
				}
			);
		}
	}

	private needsSelfChangeConfirmation(): boolean {
		if (this.isAdd) {
			return this.valRelationship === 'Self';
		}
		if (!this.historyMember) {
			return false;
		}
		const wasSelf = this.historyMember.relationship === 'Self';
		const isSelf = this.valRelationship === 'Self';
		return wasSelf !== isSelf;
	}

	private openSelfChangeConfirmDialog(): void {
		const message = 'Changing the Primary Applicant (Self) will update the case record (name, member ID, DOB, etc.). Are you sure?';
		const dialogData = new ConfirmDialogModel('Please Confirm', message);
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '450px',
			data: dialogData,
			panelClass: 'custom-dialog-container'
		});

		dialogRef.afterClosed().subscribe(dialogResult => {
			if (dialogResult === true) {
				this.performSave();
			} else {
				this.submitEnabled = true;
			}
		});
	}
}
